import Price from "../components/Price";
import { ISewerage } from "../interfaces";
import { Grid, List, ListItem, Divider, TextField } from "@mui/material";
import {
  pressuredGroupProvider,
  pressuredPriceProvider,
} from "../providers/pressuredProvider";
import { Fragment } from "react";

interface IProps {
  data: ISewerage[];
}

export default function SummaryPressured({ data }: IProps) {
  const groups = pressuredGroupProvider(data);
  const quantity = groups.reduce((acc, curr) => acc + Number(curr.quantity), 0);

  if (groups.length === 0) {
    return <></>;
  }

  return (
    <List>
      {groups.map((group, index) => (
        <Fragment key={index}>
          <ListItem disableGutters>
            <Grid
              container
              spacing={2}
              sx={{ marginRight: 23 }}
              alignItems="center"
            >
              <Grid item xs={3}>
                Mezisoučet #{index + 1}
              </Grid>
              <Grid
                item
                xs={9}
                container
                key={index}
                alignItems="center"
                spacing={2}
              >
                <Grid item xs={3}>
                  <TextField
                    label="Materiál"
                    size="small"
                    value={group.type}
                    fullWidth
                    InputProps={{ readOnly: true }}
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    label="Profil"
                    size="small"
                    value={group.profile}
                    InputProps={{ readOnly: true }}
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    label="Celková délka"
                    size="small"
                    value={group.quantity}
                    InputProps={{ readOnly: true }}
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    label="Zpevněné plochy"
                    size="small"
                    value={group.consolidated ? "Ano" : "Ne"}
                    InputProps={{ readOnly: true }}
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={2}>
                  <Price data={group} provider={pressuredPriceProvider} />
                </Grid>
              </Grid>
            </Grid>
          </ListItem>
          <Divider />
        </Fragment>
      ))}
      <ListItem disableGutters>
        <Grid
          container
          spacing={2}
          sx={{ marginRight: 23 }}
          alignItems="center"
        >
          <Grid item xs={3}>
            Celkový součet
          </Grid>
          <Grid item xs={9} container alignItems="center" spacing={2}>
            <Grid item xs={5}></Grid>
            <Grid item xs={2}>
              <TextField
                label="Celková délka"
                size="small"
                value={quantity}
                InputProps={{ readOnly: true }}
                variant="standard"
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={2}>
              <Price
                data={groups}
                isArray={true}
                provider={pressuredPriceProvider}
              />
            </Grid>
          </Grid>
        </Grid>
      </ListItem>
    </List>
  );
}
